module.exports = __webpack_public_path__ + "img/UVC8.4ca68713.png";